import { render, staticRenderFns } from "./NewProductConfiguratorEditorText.vue?vue&type=template&id=9ce4918c&"
import script from "./NewProductConfiguratorEditorText.vue?vue&type=script&lang=js&"
export * from "./NewProductConfiguratorEditorText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports